import { render, staticRenderFns } from "./BaseModal.vue?vue&type=template&id=a78484fa&"
import script from "./BaseModal.vue?vue&type=script&lang=js&"
export * from "./BaseModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a78484fa')) {
      api.createRecord('a78484fa', component.options)
    } else {
      api.reload('a78484fa', component.options)
    }
    module.hot.accept("./BaseModal.vue?vue&type=template&id=a78484fa&", function () {
      api.rerender('a78484fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Modals/BaseModal.vue"
export default component.exports